
  export const style = {
    api: {
      apiProduction: "https://aspil.prd.appnoz.com.br/",
      newApiProduction: "null",
      samlUrl: null,
      nameProfile: "Aspil",
      hostHeader: "aspil",
    },

    icons: {
      loginIcon: "https://timcoo-geral.s3.us-east-1.amazonaws.com/Logos/primary_logo_client_aspil.png",
      secondaryLogonLogo: "null",
      menuIcon: localStorage.getItem("menuIcon") || "https://timcoo-geral.s3.us-east-1.amazonaws.com/Logos/secondary_logo_client_aspil.png",
      browserLogo: "https://timcoo-geral.s3.us-east-1.amazonaws.com/Logos/favicon_logo_client_aspil.png",
    },

    shareAttributes: {
      shareImage: "https://timcoo-geral.s3.us-east-1.amazonaws.com/Logos/primary_logo_client_aspil.png",
      shareTitle: "Noz - Plataforma de comunicação",
      shareDescription: "O NOZ é um aplicativo de comunicação personalizado, onde é possível criar conteúdos de acordo com a segmentação do seu público de maneira gamificada.",
    },

    names: {
      nameApp: localStorage.getItem("nameApp") || "NOZ",
      nameScore: "Cruzetas",
      nameStore: "Loja",
      nameAcademy: localStorage.getItem("nameAcademy") || "Cursos",
      nameTeam: localStorage.getItem("nameTeam") || "Time",
      nameCalendar: localStorage.getItem("nameCalendar") || "Calendário",
      nameTools: localStorage.getItem("nameTools") || "Ferramentas",
    },

    colors: {
      primaryColor: localStorage.getItem("primaryColor") || "#1F4C82",
      secondaryColor: localStorage.getItem("secondaryColor") || "#1F4C82",
      tertiaryColor: "",
    },

    variables: {
      gamificationEnabled: true,
      child_profiles: [],
      hasPrivacyPolicies: false,
      externalUse: false,
      customClient: false,
      customMenuItem: true,
      autoRegister: false,
      recaptchaVersion: "V2",
      showBirthday: "true"
    },
  };
